import { ActionReducer } from '@ngrx/store';
import { localStorageSync } from 'ngrx-store-localstorage';

interface CustomOptions {
  serialize?: (value: string) => any;
  deserialize?: (value: string) => any;
  encrypt?: (value: string) => string;
  decrypt?: (value: string) => string;
}

export interface LocalStorageSyncConfig<T> {
  keys: (keyof T | Partial<Record<keyof T, CustomOptions>>)[];
  rehydrate?: boolean;
  storage?: Storage;
  removeOnUndefined?: boolean;
  restoreDates?: boolean;
  storageKeySerializer?: (key: string) => string;
  syncCondition?: (state: T) => any;
  checkStorageAvailability?: boolean;
  mergeReducer?: (state: T, rehydratedState: any, action: any) => any;
}

export function createLocalStorageSyncReducer<T>(config: LocalStorageSyncConfig<T>) {
  return (reducer: ActionReducer<any>): ActionReducer<any> => {
    return localStorageSync(config as any)(reducer);
  };
}
